module.exports = __webpack_public_path__ + "img/MSENG2_Cover.f4f2ff0c.jpg";